<template>
  <div class="commitment-letter-container" :class="{ 'skip-pending': !displayContent }">
    <template v-if="displayContent">
    <!-- 承诺书内容 -->
    <div class="commitment-letter">
      <h2 class="letter-title">承诺书</h2>
      
      <div class="letter-content">
        <div v-html="commitmentInfo.notice"></div>
      </div>
    </div>
    <!--  -->
    <div class="commitment-footer d-flex d-flex-center">
      <div class="checkbox-group">
        <label class="checkbox-label">
          <input 
            type="checkbox" 
            v-model="checkedItems.readPolicy"
            :disabled="hasCommitmentFile && !hasAgreedInDialog"
            class="checkbox-input"
          />
          <span class="checkbox-text">
            本人已阅读、知晓
            <a v-if="hasCommitmentFile" href="javascript:void(0)" @click="viewRefundPolicy" class="link-text">
              {{ (commitmentInfo.fileList && commitmentInfo.fileList[0] && commitmentInfo.fileList[0].name) || '相关文件' }}
            </a>
          </span>
        </label>

        <label class="checkbox-label">
          <input 
            type="checkbox" 
            v-model="checkedItems.agreeCommitment"
            class="checkbox-input"
          />
          <span class="checkbox-text">本人已阅读、知晓并同意上述承诺</span>
        </label>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="action-buttons d-flex d-flex-middle d-flex-center">
      <button 
        class="submit-btn" 
        :disabled="!canSubmit"
        @click="handleSubmit"
      >
        提交报名
      </button>
    </div>

    <!-- 退学退费管理办法弹窗 -->
    <DocumentDialog
      :visible="dialogVisible"
      :document-data="commitmentInfo.fileList && commitmentInfo.fileList[0]"
      :countdown-seconds="5"
      @cancel="handleDialogCancel"
      @submit="handleDialogSubmit"
    />
    </template>
  </div>
</template>

<script>
import DocumentDialog from '@/components/DocumentDialog.vue'
export default {
  name: 'CommitmentLetter',
  components: {
    DocumentDialog
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      commitmentInfo:{},
      checkedItems: {
        readPolicy: false,
        agreeCommitment: false
      },
      hasAgreedInDialog: false, // 是否在弹窗中点击了"阅读并同意"
      dialogVisible: false,
      displayContent: false
    }
  },
  computed: {
    hasCommitmentFile() {
      return !!(Array.isArray(this.commitmentInfo.fileList) && this.commitmentInfo.fileList.length)
    },
    hasCommitmentNotice() {
      return !this.isRichTextEmpty(this.commitmentInfo.notice)
    },
    canSubmit() {
      const readPolicyValid = this.hasCommitmentFile ? this.checkedItems.readPolicy : true
      return readPolicyValid && this.checkedItems.agreeCommitment
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    isRichTextEmpty(content) {
      const normalizedText = String(content || '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;|&#160;/gi, '')
        .replace(/\u00A0/g, '')
        .replace(/[\s\u200B-\u200D\uFEFF]/g, '')
      return !normalizedText
    },
    getInfo(){
      this.$http.get(this.MOCK_PREFIX + '/student/pc/getCommitment').then(res => {
        this.commitmentInfo = res || {}
        this.hasAgreedInDialog = !this.hasCommitmentFile
        if (this.shouldSkipCommitment()) {
          this.$emit('submit')
          return
        }
        this.displayContent = true
      }).catch(() => {
        this.displayContent = true
      })
    },
    shouldSkipCommitment() {
      return this.isRichTextEmpty(this.commitmentInfo.notice) && !this.hasCommitmentFile
    },
    handleSubmit() {
      if (!this.canSubmit) {
        this.$message.warning('请先阅读并同意相关承诺')
        return
      }
      this.$emit('submit')
    },
    viewRefundPolicy() {
      if (!this.hasCommitmentFile) {
        return
      }
      this.dialogVisible = true
    },
    handleDialogCancel() {
      this.dialogVisible = false
    },
    handleDialogSubmit() {
      this.dialogVisible = false
      this.hasAgreedInDialog = true
      this.checkedItems.readPolicy = true
    }
  }
}
</script>

<style lang="scss" scoped>
.commitment-letter-container {
  width: 100%;
  padding: 30px 0;
  position: relative;
}

.commitment-letter-container.skip-pending {
  padding: 0;
}

.commitment-letter {
  background: #F9F9F9;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px 40px;
  border: 1px solid #F3F3F3;
  margin-bottom: 20px;
}

.letter-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 30px;
}

.letter-content {
  line-height: 1.8;
  font-size: 14px;
  color: #303133;
}

.commitment-footer {
  margin: 20px auto 30px auto;
}

.checkbox-group {
  display: inline-block;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  color: #1a1a1a;
  height: 30px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  .checkbox-input {
    margin-right: 8px;
    margin-top: 1px;
    width: 14px;
    height: 14px;
    cursor: pointer;
    flex-shrink: 0;
    
    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .checkbox-text {
    flex: 1;
    line-height: 1.6;

    .link-text {
      color: #1890ff;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        color: #40a9ff;
      }
    }
  }
}

.action-buttons {
  gap: 20px;
  padding-top: 20px;
}

.submit-btn {
  width: 160px;
  height: 40px;
  background: linear-gradient(90deg, #1687DE 0%, #4084FF 100%);
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(24, 135, 222, 0.3);
  }

  &:disabled {
    background: #d9d9d9;
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>
